import React from "react";
import classNames from "classnames";
import { Link } from "gatsby";

import { ReactComponent as Logo } from "../../images/logo.svg";

import { useSiteContext } from "../SiteContext";
import { useTransitionMount } from "../../utils/hooks/transitionMount";
// import { StaticImage } from "gatsby-plugin-image";
import EyesGif from "../../images/eyes.gif";
import { Button } from "../Common/Button";
import * as styles from "./Header.module.scss";

interface HeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Header: React.FC<HeaderProps> = ({ className }) => {
  const transition = useTransitionMount();
  const { introMode, returnToHome } = useSiteContext();

  return (
    <header
      className={classNames(
        styles.header,
        { [styles.show]: !introMode, [styles.transition]: transition },
        className
      )}
    >
      <Link aria-label="Logo home page link" to="/" className={styles.logo}>
        <Logo />
      </Link>

      <div
        className={classNames(styles.middle, { [styles.show]: returnToHome })}
      >
        <Button
          to="/"
          className={styles.back}
          theme="standard"
          size="small"
          icon="arrow-right"
          iconProps={{
            className: styles.backIcon,
          }}
        >
          Back to exploring
        </Button>
      </div>

      {/* <span className={styles.watching}>
        <img src={EyesGif} alt="" />
      </span> */}
    </header>
  );
};

export { Header };
